import { render, staticRenderFns } from "./SithMesPrdSdProjectWbsList.vue?vue&type=template&id=80de50da&"
import script from "./SithMesPrdSdProjectWbsList.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdSdProjectWbsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports